import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const SectionViewAllLink = ({ to, label, testId, className = "" }) => (
  <Link
    to={to}
    data-testid={testId}
    className={`inline-flex items-center gap-2 text-sm px-5 py-3 rounded-full border transition-colors hover:scale-[1.02] ${className}`}
    style={{
      borderColor: "var(--border)",
      color: "var(--text)",
      background: "var(--surface)",
    }}
  >
    {label}
    <ArrowRight className="w-4 h-4" />
  </Link>
);

export default SectionViewAllLink;
